import React, { useEffect, useState } from "react";
import { db, collection, getDocs } from "./firebase";

function Carousel() {
  const [carouselItems, setCarouselItems] = useState([]);

  useEffect(() => {
    const fetchCarouselData = async () => {
      const querySnapshot = await getDocs(collection(db, "homeBanner"));
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCarouselItems(data);
    };

    fetchCarouselData();
  }, []);

  return (
    <div>
      <div id="carousel" className="carousel slide" data-ride="carousel">
        {/* Indicators */}
        <ol className="carousel-indicators">
          {carouselItems.map((item, index) => (
            <li
              key={index}
              data-target="#carousel"
              data-slide-to={index}
              className={index === 0 ? "active" : ""}
            ></li>
          ))}
        </ol>

        {/* Carousel Items */}
        <div className="carousel-inner">
          {carouselItems
            .sort((a, b) => (a.order || 0) - (b.order || 0))
            .map((item, index) => (
              <div
                className={`carousel-item ${index === 0 ? "active" : ""}`}
                key={item.id}
              >
                <img src={item.imageUrl} alt="Carousel Image" />
                <div className="carousel-caption">
                  <p className="animated fadeInRight">{item.caption}</p>
                  <h1 className="animated fadeInLeft">{item.title}</h1>
                  <h1 className="animated fadeInLeft"> {item.title2}</h1>
                  {item.buttonText && (
                    <a className="btn animated fadeInUp" href={item.buttonLink}>
                      {item.buttonText}
                    </a>
                  )}
                </div>
              </div>
            ))}
        </div>

        {/* Controls */}
        <a
          className="carousel-control-prev"
          href="#carousel"
          role="button"
          data-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="sr-only">Previous</span>
        </a>
        <a
          className="carousel-control-next"
          href="#carousel"
          role="button"
          data-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="sr-only">Next</span>
        </a>
      </div>
    </div>
  );
}

export default Carousel;
